
import BlokkliComponent_tomas_index from '../../components/Paragraph/TomasWidget/index.vue'
import BlokkliComponent_webform_index from '../../components/Paragraph/Webform/index.vue'
import BlokkliFragmentComponent_countdown from '../../components/Paragraph/BlokkliFragment/Countdown/index.vue'
import BlokkliFragmentComponent_mailchimp_signup_form from '../../components/Paragraph/BlokkliFragment/MailchimpSignupForm/index.vue'
import BlokkliFragmentComponent_ostendis_jobs from '../../components/Paragraph/BlokkliFragment/OstendisJobs/index.vue'
import BlokkliFragmentComponent_tomas_shop from '../../components/Paragraph/BlokkliFragment/TomasShop/index.vue'
import BlokkliFragmentComponent_tours_search_form from '../../components/Paragraph/BlokkliFragment/ToursSearchForm/index.vue'
import BlokkliFragmentComponent_team_list from '../../components/Paragraph/BlokkliFragment/TeamList/index.vue'
import BlokkliFragmentComponent_zurich_card_widget from '../../components/Paragraph/BlokkliFragment/ZurichCardWidget/index.vue'

const rare: Record<string, any> = {
  block_tomas: BlokkliComponent_tomas_index,
  block_webform: BlokkliComponent_webform_index,
  fragment_countdown: BlokkliFragmentComponent_countdown,
  fragment_mailchimp_signup_form: BlokkliFragmentComponent_mailchimp_signup_form,
  fragment_ostendis_jobs: BlokkliFragmentComponent_ostendis_jobs,
  fragment_tomas_shop: BlokkliFragmentComponent_tomas_shop,
  fragment_tours_search_form: BlokkliFragmentComponent_tours_search_form,
  fragment_team_list: BlokkliFragmentComponent_team_list,
  fragment_zurich_card_widget: BlokkliFragmentComponent_zurich_card_widget
}
export default rare